import React, { useState } from 'react';

const defaultValue = {
  recorrencias: [],
  recorrenciaAtual: {},
  selecao: [],
  tipoSelecao: 'NENHUM',
  loading: false,
  totalElements: 0,
  dataVencimentoInicio: null,
  dataVencimentoFim: null,
  page: 0,
  size: 0,
  sort: 'dataVencimento,DESC',
};

export const ContaReceberRecorrenciaContext = React.createContext({});

export const ContaReceberRecorrenciaProvider = (props) => {
  return (
    <ContaReceberRecorrenciaContext.Provider
      value={{
        recorrencias: useState(defaultValue.recorrencias),
        recorrenciaAtual: useState(defaultValue.recorrenciaAtual),
        selecao: useState(defaultValue.selecao),
        tipoSelecao: useState(defaultValue.tipoSelecao),
        loading: useState(defaultValue.loading),
        totalElements: useState(defaultValue.totalElements),
        dataVencimentoInicio: useState(defaultValue.dataVencimentoInicio),
        dataVencimentoFim: useState(defaultValue.dataVencimentoFim),
        page: useState(defaultValue.page),
        size: useState(defaultValue.size),
        sort: useState(defaultValue.sort),
      }}
    >
      {props.children}
    </ContaReceberRecorrenciaContext.Provider>
  );
};

export const ContaReceberRecorrenciaConsumer = ContaReceberRecorrenciaContext.Consumer;
